// The story ships dark: it is off unless `?story=1` is in the URL. The page's own URL is read once at load, because
// joining rewrites it to `?room=<code>` (main.ts keeps `story=1` there too, so a reload stays in story mode).
const OPENED_WITH = typeof location !== 'undefined' ? location.search : '';
export function storyOn(search: string = OPENED_WITH): boolean {
  return new URLSearchParams(search).get('story') === '1';
}